import { render, staticRenderFns } from "./RelatorioPontoDiarioPage.vue?vue&type=template&id=a1dae7c6&scoped=true"
import script from "./RelatorioPontoDiarioPage.vue?vue&type=script&lang=js"
export * from "./RelatorioPontoDiarioPage.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPontoDiarioPage.vue?vue&type=style&index=0&id=a1dae7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dae7c6",
  null
  
)

export default component.exports